import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const navClassName = `main-nav ${!isHomePage || isScrolled ? 'scrolled' : 'top'}`;

  return (
    <>
      <nav className={navClassName}>
        <div className="nav-content">
          <div className="nav-left-group">
            <Link to="/" className="nav-logo-link">
              <img src="/logo.svg" alt="Sunnfjord Naprapatsenter Logo" className="nav-logo" />
            </Link>
            <div className="nav-links-left">
              <Link className="nav-link" to="/">Hjem</Link>
              <Link className="nav-link" to="/hva-er-naprapati">Hva er naprapati?</Link>
              <Link className="nav-link" to="/om-oss">Om oss</Link>
              <Link className="nav-link" to="/priser">Priser</Link>
              <Link className="nav-link" to="/kontakt">Kontakt</Link>
              <Link className="nav-link" to="/bedrift">Bedrift</Link>
            </div>
          </div>
          <div className="nav-button-right">
            <a href="https://napforde.bestille.no/" target="_blank" rel="noopener noreferrer" className="button nav-button">
              Bestill time
            </a>
          </div>
          
          <button 
            className={`hamburger-button ${isMobileMenuOpen ? 'open' : ''}`} 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Åpne meny"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </nav>

      <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
        <Link className="nav-link" to="/">Hjem</Link>
        <Link className="nav-link" to="/hva-er-naprapati">Hva er naprapati?</Link>
        <Link className="nav-link" to="/om-oss">Om oss</Link>
        <Link className="nav-link" to="/priser">Priser</Link>
        <Link className="nav-link" to="/kontakt">Kontakt</Link>
        <Link className="nav-link" to="/bedrift">Bedrift</Link>
        <a 
          href="https://napforde.bestille.no/" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="button nav-button"
          onClick={() => setIsMobileMenuOpen(false)} 
        >
          Bestill time
        </a>
      </div>
    </>
  );
}

export default Navigation;